import { createRoot } from "react-dom/client";
import { GameClient } from "../app/game/GameClient";
import "../app/globals.css";

// GameClient owns a long-lived simulation Worker. React StrictMode's
// development-only effect replay would dispose that Worker between the setup
// render and the first command, so the static entry mounts it once.
createRoot(document.getElementById("root")!).render(<GameClient />);
